import $ from 'jquery';

window.$ = $;
window.jQuery = $;
window.jquery = $; // bazı eski plugin'ler için

export default $;
